export const TrainingDocumentComponent = () => {
  return (
    <div>
      <div>ID Document</div>
    </div>
  );
};
